import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMediaEventComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
            @variantChannelActions={{hash openNewRecord=false openRecord=false}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='headline' />
            <fieldset.field @property='startDate' @type='date' />
            <fieldset.field @property='startTime' @type='time' />
            <fieldset.field @property='endDate' @type='date' />
            <fieldset.field @property='text' @type='text-editor' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='ownedByChannel'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='partners'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
